import { render, staticRenderFns } from "./StatisticsArea.vue?vue&type=template&id=7350546d&scoped=true&"
import script from "./StatisticsArea.vue?vue&type=script&lang=js&"
export * from "./StatisticsArea.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsArea.vue?vue&type=style&index=0&id=7350546d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350546d",
  null
  
)

export default component.exports